export default "__VITE_ASSET__C9SIZa2j__"